// Base64 URL encoding/decoding utilities for push notifications

/**
 * Convert a base64 URL string to Uint8Array
 */
export function base64UrlToUint8Array(base64UrlData) {
  const padding = '='.repeat((4 - base64UrlData.length % 4) % 4);
  const base64 = (base64UrlData + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const buffer = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    buffer[i] = rawData.charCodeAt(i);
  }

  return buffer;
}

/**
 * Convert Uint8Array to base64 URL string
 */
export function uint8ArrayToBase64Url(uint8Array) {
  const base64 = window.btoa(String.fromCharCode(...uint8Array));
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

/**
 * Convert CryptoKeys to Uint8Array for VAPID
 */
export async function cryptoKeysToUint8Array(publicKey, privateKey) {
  const exportedPublicKey = await crypto.subtle.exportKey('raw', publicKey);
  const exportedPrivateKey = await crypto.subtle.exportKey('pkcs8', privateKey);

  // For P-256 curve, the private key is 32 bytes starting at offset 36 in PKCS8 format
  const privateKeyArray = new Uint8Array(exportedPrivateKey).slice(36, 68);

  return {
    publicKey: new Uint8Array(exportedPublicKey),
    privateKey: privateKeyArray
  };
}

/**
 * Generate VAPID keys
 */
export async function generateVapidKeys() {
  const keys = await crypto.subtle.generateKey(
    { name: 'ECDH', namedCurve: 'P-256' },
    true,
    ['deriveBits']
  );

  return cryptoKeysToUint8Array(keys.publicKey, keys.privateKey);
}
